import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=43969f56&scoped=true"
import script from "./chapter.vue?vue&type=script&lang=js"
export * from "./chapter.vue?vue&type=script&lang=js"
import style0 from "./chapter.vue?vue&type=style&index=0&id=43969f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43969f56",
  null
  
)

export default component.exports